import React, { useEffect, useState } from 'react';
import { DateRangePicker } from '@quintype/em/components/date-range-picker';
import subDays from 'date-fns/subDays';
import getUnixTime from 'date-fns/getUnixTime';
import fromUnixTime from 'date-fns/fromUnixTime';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
import set from 'date-fns/set';
import Select from '../../components/library-components/SelectFieldWithLabel/SelectFieldWithLabel';
import DataCard from './data_card';
import './past_renewals.scss';
import { getSubscriptionsPastRenewals } from '../../api';

const intervalOptions = [
  { value: 7, label: 'Last 7 days' },
  { value: 15, label: 'Last 15 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 60, label: 'Last 60 days' },
  { value: 90, label: 'Last 90 days' },
  { value: 'custom', label: 'Custom date range' }
];

const getUTCformattedDate = (date) => {
  const isoDate = date.toISOString();
  return isoDate.slice(0, 10); // formated date yyyy-mm-dd
};

const getDatesFromInterval = (interval) => {
  const endDate = subDays(new Date(), 1);
  const startDate = subDays(new Date(), interval);
  return [startDate, endDate];
};

const getInitialUnixStamp = () => {
  const yesterday = subDays(new Date(), 1);
  const sevenDaysAgo = subDays(new Date(), 7);

  return [getUnixTime(sevenDaysAgo), getUnixTime(yesterday)];
};

const getAPIdates = (interval, timestamp) => {
  if (typeof interval.value === 'string') {
    return {
      from_date: getUTCformattedDate(fromUnixTime(timestamp.start)),
      to_date: getUTCformattedDate(fromUnixTime(timestamp.end))
    };
  }

  const [fromDate, toDate] = getDatesFromInterval(interval.value);
  return {
    from_date: getUTCformattedDate(fromDate),
    to_date: getUTCformattedDate(toDate)
  };
};

const validatePastDate = ({ endTimeStamp }) => {
  const endDate = fromUnixTime(endTimeStamp);
  const today = set(new Date(), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });
  const isTodayOrPastDate = isBefore(endDate, today) || isEqual(endDate, today);
  if (!isTodayOrPastDate) {
    return {
      type: 'to',
      message: 'To date should be today or in the past'
    };
  }
};

const PastRenewals = () => {
  const [timestamp, setTimeStamp] = useState({
    start: getInitialUnixStamp()[0],
    end: getInitialUnixStamp()[1]
  });
  const [interval, setInterval] = useState(intervalOptions[0]); // Default to "Last 7 days"
  const [dueToRenew, setDueToRenew] = useState(0);
  const [successfullyRenewed, setSuccessfullyRenewed] = useState(0);
  const [failedRenewals, setFailedRenewals] = useState(0);

  useEffect(() => {
    getSubscriptionsPastRenewals(getAPIdates(interval, timestamp)).then(
      (result) => {
        setDueToRenew(result.due_to_renew);
        setSuccessfullyRenewed(result.successfully_renewed);
        setFailedRenewals(result.failed_renewals);
      }
    );
  }, [interval.value, timestamp.start, timestamp.end]);

  return (
    <div className="past-renewals__container">
      <div className="past-renewals__header">
        <h2 className="past-renewals__title">PAST RECCURING RENEWALS</h2>
        <div className="past-renewals__filters">
          <div className="past-renewals__interval">
            <Select
              options={intervalOptions}
              onChange={setInterval}
              value={interval}
              label="Interval"
              clearable={false}
            />
            {interval.value === 'custom' && (
              <DateRangePicker
                startTimeStamp={timestamp.start}
                endTimeStamp={timestamp.end}
                onDateRangeSelect={(start, end) => {
                  setTimeStamp({
                    start,
                    end
                  });
                }}
                customValidation={validatePastDate}
              />
            )}
          </div>
        </div>
      </div>
      <div className="past-renewals__cards">
        <DataCard
          id="past-due-to-renew"
          title="Due to Renew"
          currentValue={dueToRenew}
        />
        <DataCard
          id="past-successfully-renewed"
          title="Successfully Renewed"
          currentValue={successfullyRenewed}
        />
        <DataCard
          id="past-failed-renewals"
          title="Failed Renewals"
          currentValue={failedRenewals}
        />
      </div>
    </div>
  );
};

export default PastRenewals;
